module.exports = require("core-js/modules/esnext.map.delete-all.js");